import sidebar from '@/config/sidebars/geogrids'
import createVueApp from '@/common/create_app'
import { useWidgetFormStore } from '@/stores/geogrids/widget_form'

const hydrateForm = (props) => (pinia) => {
  const form = useWidgetFormStore(pinia)
  form.setOptions({
    gridSizes: props.gridSizes,
    distanceMeasures: props.gridDistanceMeasures,
    pointDistances: props.pointDistances,
    kinds: props.kinds,
    scriptUrl: props.scriptUrl,
    whiteLabelConfigurations: props.whiteLabelConfigurations
  })
  form.setWidget(props.geogridWidget)
}

const mountForm = async(props) => {
  const { default: Component } = await import('@/vue_widgets/geogrids/widgets/form/index.vue')
  createVueApp(Component, { sidebar, state: hydrateForm(props) })
}

Styxie.Initializers.GeogridWidgets = {
  index: async() => {
    const { default: Component } = await import('@/vue_widgets/geogrids/widgets/index/index.vue')
    createVueApp(Component, { sidebar })
  },
  new: mountForm,
  edit: mountForm
}
